module.exports = __webpack_public_path__ + "03_glasses_black.83f5d601.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer4/03_glasses_black.png
// module id = oVlT
// module chunks = 0